import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import GlobalFooter from '../GlobalFooter';

function PaymentEurAccount() {
  const record = JSON.parse(localStorage.getItem('auth'));

  const location = useLocation();

  // const queryParams = new URLSearchParams(location.search);

  // const business_name = queryParams.get('business_name');
  // const payableFxAmountString = queryParams.get('payableFxAmountString');
  // const amount = queryParams.get('amount');
  // const transactionId = queryParams.get('transactionId');
  // const currency = queryParams.get('currency');
  // const redirectLink = queryParams.get('redirectLink');
  const [copiedText, setCopiedText] = useState('');
  const navigate = useNavigate();
  const handleClose = () => {
    navigate('/pages/payment-credential');
  };
  const handleSubmit = () => {
    return navigate('/pages/institutions');
  };
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    setCopiedText(text);
    toast('Copied successfully');
  };
  return (
    <div className="global_layout">
      {/* {
                 record?.avatar ?
                 <div className='img_container'>
                     <img className='img_glob' src={record?.avatar} alt=''/>
                 </div>:
                <div className='glob_avater custom_avater'>
                    <p className='glob_avater_text'>{String(record?.data?.business_name).slice(0, 1)}</p>
                </div>
        } */}

      <div className="global_container">
        <div className="top_bar">
          <img
            src="/images/global/arrow-left.svg"
            alt=""
            onClick={handleClose}
          />
          <img src="/images/global/close.svg" alt="" onClick={handleClose} />
        </div>

        <div className="global_content">
          <div className="glob_avater">
            {record?.avatar ? (
              <img className="img_avater" src={record?.avatar} alt="" />
            ) : (
              <p className="glob_avater_text">
                {String(record?.data?.business_name).slice(0, 1)}
              </p>
            )}
          </div>

          <div className="account_patterns">
            <div className="amount_contents">
              <div className="name_amount">
                <img src="/images/global/briefcase.svg" alt="" />
                <p className="glob_name">Payment total</p>
              </div>
              <h6 className="name_value">{record?.payableFxAmountString}</h6>
            </div>
          </div>
          <p
            className="glob_desc_text"
            style={{ marginTop: '16px', textAlign: 'center' }}
          >
            We have partnered with Yapily Connect to securely initiate payment
            from your account
          </p>
          <p className="glob_desc_text" style={{ marginTop: '13px' }}>
            By using the service, you agree to Yapily Connect initiating this
            payment and its{' '}
            <a
              className="privacy_link"
              href="https://getflick.co/terms-conditions"
              target="_blank"
            >
              Terms & Conditions and Privacy Notice
            </a>
          </p>
          {/* Phone Number */}

          <button
            className="globalBtn"
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: '18px',
              gap: '8px',
            }}
            onClick={handleSubmit}
          >
            <p>Confirm</p>

            {/* <img src='/images/global/activeArrow.svg' alt='' /> */}
          </button>
        </div>
      </div>
      {!record?.total_whitelabelling && <GlobalFooter />}
    </div>
  );
}

export default PaymentEurAccount;
